import { render, staticRenderFns } from "./CustomerSelect.vue?vue&type=template&id=65f4dcd3&scoped=true"
import script from "./CustomerSelect.vue?vue&type=script&lang=js"
export * from "./CustomerSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65f4dcd3",
  null
  
)

export default component.exports